import produce from 'immer';
import _ from 'underscore';

import {NLOToServerId} from 'notebook/ELNConstants';
import {cidPrefix} from 'notebook/embeddings/NoteLinkedEmbeddingUtil';
import {
  ChartNotePart,
  FromServerNoteLinkedChart,
  NoteLinkedChart,
} from 'notebook/integrations/charts/NoteLinkedChartTypes';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';

export const CHART_CID_PREFIX = 'chart-';

export function prepareForStore(item: FromServerNoteLinkedChart, cidIdMap: CidIdMap): void {
  addCid(item, cidPrefix, cidIdMap);
  const preparedItem = item as unknown as NoteLinkedChart;
  preparedItem.chart.cid = _.uniqueId(CHART_CID_PREFIX);
  if (item.chart.id == null) {
    throw new Error('Expected note linked chart from server to have a chart id.');
  }
  cidIdMap[preparedItem.chart.cid] = item.chart.id;
}

export function prepareForSave(item: NoteLinkedChart, cidIdMap: CidIdMap): NLOToServerId {
  const chartId = item.chart.cid ? cidIdMap[item.chart.cid] : item.chart.id;
  const {source_id: sourceId, ...chartForSave} = item.chart;
  return {
    id: cidIdMap[item.cid] as string,
    type: item.type,
    cid: item.cid,
    name: item.name,
    chart: {
      ...chartForSave,
      id: typeof chartId === 'string' ? chartId : null,
      ...(typeof chartId === 'string' ? {} : {source_id: sourceId ?? item.chart.id}),
    },
  } as unknown as NLOToServerId;
}

export function copyNoteLinkedChartForPaste({
  source,
  shouldCloneChart,
}: {
  source: NoteLinkedChart;
  shouldCloneChart: boolean;
}): NoteLinkedChart {
  return produce(source, (draft) => {
    draft.cid = _.uniqueId(cidPrefix);
    if (shouldCloneChart) {
      draft.chart.cid = _.uniqueId(CHART_CID_PREFIX);
      draft.chart.source_id = draft.chart.source_id ?? draft.chart.id ?? undefined;
    }
  });
}

export function convertItemForPaste(item: ChartNotePart): {
  addedItem: ChartNotePart;
  oldName: string;
  newName: string;
} {
  return {addedItem: item, oldName: item.item.name, newName: item.item.name};
}
